import styled from 'styled-components/macro';
import { Popover } from '@redis-ui/components';

export const PopoverCell = styled(Popover)`
  color: ${({ theme }) =>
    theme.appComponents.shared.table.components.cellFilter.cellFilter.text.color};
`;
